// ==================================================
// RANKINGS DATA (TEMP — API READY)
// ==================================================

import type { RankingTeam } from "./rankingsEngine";

/* ================= MEN ================= */

export const mensRankingsData: RankingTeam[] = [
  { team: "South Africa", country: "south-africa", points: 93.96 },
  { team: "New Zealand", country: "new-zealand", points: 92.28 },
  { team: "Ireland", country: "ireland", points: 88.08 },
  { team: "France", country: "france", points: 87.43 },
  { team: "England", country: "england", points: 85.68 },
  { team: "Scotland", country: "scotland", points: 84.78 },
  { team: "Argentina", country: "argentina", points: 83.13 },
  { team: "Australia", country: "australia", points: 81.61 },
  { team: "Fiji", country: "fiji", points: 78.00 },
  { team: "Wales", country: "wales", points: 76.38 },
  { team: "Italy", country: "italy", points: 76.30 },
  { team: "Japan", country: "japan", points: 75.94 },
  { team: "Georgia", country: "georgia", points: 73.94 },
  { team: "United States", country: "united-states-of-america", points: 70.22 },
  { team: "Portugal", country: "portugal", points: 69.39 },
];

/* ================= WOMEN ================= */

export const womensRankingsData: RankingTeam[] = [
  { team: "England", country: "england", points: 98.09 },
  { team: "Canada", country: "canada", points: 91.53 },
  { team: "New Zealand", country: "new-zealand", points: 89.85 },
  { team: "France", country: "france", points: 83.60 },
  { team: "Ireland", country: "ireland", points: 78.20 },
  { team: "Scotland", country: "scotland", points: 77.39 },
  { team: "Australia", country: "australia", points: 75.46 },
  { team: "United States", country: "united-states-of-america", points: 72.90 },
  { team: "Italy", country: "italy", points: 72.37 },
  { team: "South Africa", country: "south-africa", points: 71.62 },
  { team: "Japan", country: "japan", points: 69.72 },
  { team: "Wales", country: "wales", points: 66.13 },
  { team: "Fiji", country: "fiji", points: 63.98 },
  { team: "Spain", country: "spain", points: 62.42 },
  { team: "Samoa", country: "samoa", points: 59.72 },
];